import AssetSVG from 'assets/Asset.svg?react';
import BaseStationSVG from 'assets/BaseStation.svg?react';
import BaseStationOfflineSVG from 'assets/BaseStationOffline.svg?react';
import BaseStationOnlineSVG from 'assets/BaseStationOnline.svg?react';
import HubSVG from 'assets/Hub.svg?react';
import PiezoSensingSVG from 'assets/PiezoSensing.svg?react';
import RepeaterSVG from 'assets/Repeater.svg?react';
import SensorSVG from 'assets/Sensor.svg?react';
import SensorAwolSVG from 'assets/SensorAWOL.svg?react';
import SensorOfflineSVG from 'assets/SensorOffline.svg?react';
import SensorOnlineSVG from 'assets/SensorOnline.svg?react';
import { SvgIcon, SvgIconProps } from 'components/svg_icon/SvgIcon';
import { Lookup } from 'utils/types';

export type HardwareIconType =
    | 'asset'
    | 'baseStation'
    | 'baseStationOnline'
    | 'baseStationOffline'
    | 'hub'
    | 'repeater'
    | 'sensor'
    | 'sensorOnline'
    | 'sensorOffline'
    | 'sensorAWOL'
    | 'piezoSensing';

const icons: Lookup<HardwareIconType, SVGComponent> = {
    asset: AssetSVG,
    baseStation: BaseStationSVG,
    baseStationOnline: BaseStationOnlineSVG,
    baseStationOffline: BaseStationOfflineSVG,
    hub: HubSVG,
    repeater: RepeaterSVG,
    sensor: SensorSVG,
    sensorOnline: SensorOnlineSVG,
    sensorOffline: SensorOfflineSVG,
    sensorAWOL: SensorAwolSVG,
    piezoSensing: PiezoSensingSVG,
};

export type HardwareIconProps = Omit<SvgIconProps, 'component'> &
    Readonly<{
        type: HardwareIconType;
    }>;

/**
 * Component for displaying different hardware icons.
 */
export function HardwareIcon({ type, ...rest }: HardwareIconProps) {
    return <SvgIcon {...rest} component={icons[type]} />;
}
